import React, {useState} from "react";
import {Autocomplete, ClickAwayListener} from "@mui/material";
import TextField from "./TextField";

export interface MultiValueTextFieldProps {
    label?: string,
    values: string[],
    onChange?: (changedValues: string[]) => void,
    validateValueBeforeAdd?: (newValue: string) => boolean,
    required?: boolean,
    readOnly?: boolean,
    helperText?: string;
    errorMessage?: string,
}

export default function MultiValueTextField(props: Readonly<MultiValueTextFieldProps>) {
    const {label, values, onChange, validateValueBeforeAdd, required, helperText, errorMessage} = props;

    const [opened, setOpened] = useState<boolean>(false);

    return (
            <ClickAwayListener onClickAway={() => setOpened(false)}>
                <Autocomplete
                        open={opened}
                        value={values}
                        options={[]}
                        size={"small"}
                        multiple={true}
                        limitTags={-1}
                        freeSolo={true}
                        forcePopupIcon={false}
                        popupIcon={null}
                        disableCloseOnSelect={true}
                        renderInput={
                            (params) => (
                                    <TextField
                                            {...params}
                                            label={label}
                                            required={required}
                                            readOnly={props.readOnly}
                                            helperText={helperText}
                                            errorMessage={errorMessage} />
                            )
                        }
                        onChange={(e, values, reason, details) => {
                            if (reason === "createOption" && details?.option && validateValueBeforeAdd) {
                                const value = details.option as unknown;
                                if (!validateValueBeforeAdd(value as string)) {
                                    return;
                                }
                            }
                            onChange?.(values as string[]);
                            e.stopPropagation();
                        }}

                        onOpen={() => setOpened(true)}
                        onClose={() => setOpened(false)} />
            </ClickAwayListener>
    );
}
